var SitePage = require('../views/masters/SitePage');
var $ = require('jquery');

var PATH_CUPON = '/suscriptor/beneficio/json/case/quierolapromo';
var PATH_SUCURSALES = '/suscriptor/beneficio/sucursales-por-establecimientos';

var PATH_MARKET_ACTIVE = '/static/2016/d/public/img/markeractive.svg';
var PATH_MARKET_INACTIVE = '/static/2016/d/public/img/markerinactive.svg';

var COORDENADAS_MAPS = {
  1: {
    title: 'Sally beauty / Jockey Plaza',
    lat: -12.085990501480634,
    lng: -76.97709547088617,
    address: 'Centro Comercial Jockey Plaza, Av. Javier Prado Este 4200, Santiago de Surco 15023'
  },
  2: {
    title: 'Sally beauty / Centro Civico',
    lat: -12.056720703391864,
    lng: -77.03756680000004,
    address: 'Real Plaza Centro Civico, Av. Garcilaso de la Vega 1337, Lima 15001'
  },
  3: {
    title: 'Sally beauty / Santa Anita',
    lat: -12.056636766003969,
    lng: -76.97099705445942,
    address: 'Nicolas Ayllon, Santa Anita 15008'
  }
};

/**
 * Beneficio
 * @constructor
 * @description represent Home Page
 * @extends SitePage
 * @param {Object} options - object contain any attributes
 */
function Beneficio(options){
    SitePage.call(this);
    this.options = options;
    this.fetch = false;
    this.arraySucursales = [];
    this.currentMarker = null;
    this.map = null;
    this.arrayMarkers = [];
}

Beneficio.prototype = $.extend(Object.create(SitePage.prototype), {

  constructor: Beneficio,

  /**
   * Executes when document DOM Tree is ready.
   */

  ready: function() {
    console.log("Ready:   ");
    SitePage.prototype.ready.call(this);

    $('.block-sucursales').on('click', this._closeModalMap.bind(this));

    $('.cont-sucursales').on('click', function(evt){ evt.stopPropagation(); });

    var $btnCupon = $('#btn-cupon'),
        $btnIngresarHeader = $('.ingresar-button-header'),
        $minBoxIngresar = $('.min-box-ingresar');

    $btnCupon.on('click', function (evt) {
      evt.preventDefault();
      var statusLogin = $(evt.target).data('login');
      if (statusLogin) this._obtenerCupon();
      else SitePage.prototype._showPopup($minBoxIngresar, $btnIngresarHeader);
    }.bind(this));

    $('#btnGallery').on('click', this._scrollTopSection);
    $('#btnVideo').on('click', this._scrollTopSection);
    $('#btnSucursales').on('click', this._openSucursales.bind(this));
    $('.block-sucursales .button-close').on('click', this._closeModalMap);

    $('.modal-sucursales .next').on('click', this._next.bind(this));
    $('.modal-sucursales .prev').on('click', this._prev.bind(this));
  },

  _scrollTopSection : function (evt) {
    evt.preventDefault();
    if (!$(this).parents('.tipo').hasClass('tipo-disable')) {
      var id = $(this).attr('data-section'),
          less = ($(window).scrollTop() > 0) ? 130 : 230;
      $('html,body').animate({
        scrollTop: $("#" + id).offset().top - less
      }, 1500);
    }
  },

  _obtenerCupon: function (evt){
    var $form = $('#frmAplicaPromo'),
        msg = $form.find(".msg-form");
        // loading = $form.find('.loader-ajax');

        // loading.removeClass('display_off');

    $.ajax({ url: PATH_CUPON, data: $form.serialize(), type: 'POST', dataType: 'json' })
          .done(function (response) {
              if(response.popup){
                    if(response.mensaje){
                        if($('.msgbox').length){
                            $('.msgbox').remove();
                        }

                        var html = '<div class="msgbox error">';
                                html += '<div class="cont-msgbox">';
                                    html += '<div class="desc-msgbox">';
                                        html += '<span> ' + response.message + '</span>';
                                    html += '</div>';
                                html += '</div>';
                            html += '</div>';

                        $('.cont_header').before(html);
                    }else{
                        $form.attr('action',response.url);
                    }

                }else{
                    $form.attr('action',response.url);
                    $form.submit();
                }
          })
          .fail(function (error) {
            msg.removeClass('display_off').addClass('msg-error').text(error.message);
          });
  },

  _closeModalMap: function (evt){
    evt.preventDefault();
    $('.block-sucursales').fadeOut();
    this._deleteMarkers();
  },

  _openSucursales: function (evt){
    evt.preventDefault();
    $('.block-sucursales').fadeIn();

    var myOptions = {
          zoom: 13,
          // mapTypeId: google.maps.MapTypeId.ROADMAP,

          // panControl: true,
          mapTypeControl: false,
          // panControlOptions: {
          //     position: google.maps.ControlPosition.RIGHT_CENTER
          // },
          center: {
            lat: -12.055304424874748,
            lng: -77.04522270000001
          },
          zoomControl: true,
          zoomControlOptions: {
              style: google.maps.ZoomControlStyle.LARGE,
              position: google.maps.ControlPosition.RIGHT_CENTER
          },
          scaleControl: false,
          streetViewControl: false,
          streetViewControlOptions: {
              position: google.maps.ControlPosition.RIGHT_CENTER
          }
      };
    var styles = [
                  {
                      "featureType": "all",
                      "elementType": "labels",
                      "stylers": [
                          {
                              "visibility": "on"
                          }
                      ]
                  },
                  {
                      "featureType": "administrative",
                      "elementType": "all",
                      "stylers": [
                          {
                              "visibility": "simplified"
                          },
                          {
                              "color": "#5b6571"
                          },
                          {
                              "lightness": "35"
                          }
                      ]
                  },
                  {
                      "featureType": "administrative.neighborhood",
                      "elementType": "all",
                      "stylers": [
                          {
                              "visibility": "off"
                          }
                      ]
                  },
                  {
                      "featureType": "landscape",
                      "elementType": "all",
                      "stylers": [
                          {
                              "visibility": "on"
                          },
                          {
                              "color": "#f3f4f4"
                          }
                      ]
                  },
                  {
                      "featureType": "landscape.man_made",
                      "elementType": "geometry",
                      "stylers": [
                          {
                              "weight": 0.9
                          },
                          {
                              "visibility": "on"
                          }
                      ]
                  },
                  {
                      "featureType": "landscape.natural",
                      "elementType": "labels",
                      "stylers": [
                          {
                              "color": "#7f7f7f"
                          },
                          {
                              "saturation": "0"
                          },
                          {
                              "weight": "0.02"
                          }
                      ]
                  },
                  {
                      "featureType": "poi.park",
                      "elementType": "geometry.fill",
                      "stylers": [
                          {
                              "visibility": "on"
                          },
                          {
                              "color": "#83cead"
                          }
                      ]
                  },
                  {
                      "featureType": "road",
                      "elementType": "all",
                      "stylers": [
                          {
                              "visibility": "on"
                          },
                          {
                              "color": "#ffffff"
                          }
                      ]
                  },
                  {
                      "featureType": "road",
                      "elementType": "labels",
                      "stylers": [
                          {
                              "visibility": "on"
                          }
                      ]
                  },
                  {
                      "featureType": "road",
                      "elementType": "labels.text",
                      "stylers": [
                          {
                              "saturation": "0"
                          },
                          {
                              "visibility": "on"
                          }
                      ]
                  },
                  {
                      "featureType": "road.highway",
                      "elementType": "all",
                      "stylers": [
                          {
                              "visibility": "on"
                          },
                          {
                              "color": "#fee379"
                          }
                      ]
                  },
                  {
                      "featureType": "road.highway",
                      "elementType": "geometry",
                      "stylers": [
                          {
                              "visibility": "on"
                          }
                      ]
                  },
                  {
                      "featureType": "road.highway",
                      "elementType": "labels",
                      "stylers": [
                          {
                              "visibility": "on"
                          }
                      ]
                  },
                  {
                      "featureType": "road.highway",
                      "elementType": "labels.text",
                      "stylers": [
                          {
                              "color": "#545252"
                          },
                          {
                              "weight": "0.01"
                          }
                      ]
                  },
                  {
                      "featureType": "road.highway",
                      "elementType": "labels.icon",
                      "stylers": [
                          {
                              "visibility": "on"
                          }
                      ]
                  },
                  {
                      "featureType": "road.highway.controlled_access",
                      "elementType": "labels.icon",
                      "stylers": [
                          {
                              "visibility": "on"
                          }
                      ]
                  },
                  {
                      "featureType": "road.arterial",
                      "elementType": "all",
                      "stylers": [
                          {
                              "visibility": "simplified"
                          },
                          {
                              "color": "#ffffff"
                          }
                      ]
                  },
                  {
                      "featureType": "road.arterial",
                      "elementType": "labels",
                      "stylers": [
                          {
                              "visibility": "on"
                          },
                          {
                              "color": "#787575"
                          },
                          {
                              "weight": "0.01"
                          }
                      ]
                  },
                  {
                      "featureType": "road.arterial",
                      "elementType": "labels.icon",
                      "stylers": [
                          {
                              "visibility": "on"
                          }
                      ]
                  },
                  {
                      "featureType": "road.local",
                      "elementType": "labels",
                      "stylers": [
                          {
                              "color": "#958c8c"
                          },
                          {
                              "weight": "0.01"
                          }
                      ]
                  },
                  {
                      "featureType": "water",
                      "elementType": "all",
                      "stylers": [
                          {
                              "visibility": "on"
                          },
                          {
                              "color": "#7fc8ed"
                          }
                      ]
                  }
              ];
    var inforWindow = new google.maps.InfoWindow({
      content: '',
      maxWidth: 200
    });
    this.map = new google.maps.Map(document.getElementById("map"), myOptions);
    this.map.setOptions({styles: styles})

    if (!this.fetch){
      var promisePlace = $.ajax({url: PATH_SUCURSALES, type: 'GET', dataType: 'json', data: {'beneficio_id' : $('input[name="beneficio_id"]').val()}});
      promisePlace
        .done(function(res) {
          if (!res.success){
            console.log(res.mensaje);
          } else {
            this.arraySucursales = res.data;
            this.currentMarker = res.data[0];
            this.fetch = true;
            this._drawContentMap(this, inforWindow);
          }
        }.bind(this))
        .fail(function(error) {
          console.log(error.statusText);
        });
    } else {
      //consulta a WS para obtener lista de coordenadas.
      // this.arraySucursales = Object.keys(COORDENADAS_MAPS).map(function (index) { return COORDENADAS_MAPS[index]; });
      this.currentMarker = this.arraySucursales[0];
      this._drawContentMap(this, inforWindow);
    }


    // var latLng = new google.maps.LatLng(this.currentMarker.lat, this.currentMarker.lng);
    // var markerInit = this._addMarker(this.map, '/static/2016/d/public/img/markeractive.svg', latLng);
    // this.arrayMarkers.push(markerInit);
    // this.map.setCenter(markerInit.position);
    // var content = '<div><p>' + this.currentMarker.address + '</p></div>';
    // this._createWindowContent(inforWindow, this.map, content, markerInit);
    // google.maps.event.trigger(markerInit, 'click');
    // $('.title-sucursales').find('h2').text(this.currentMarker.title);
    // $('.somenumbers').text('/' + this.arraySucursales.length);

    // // var bounds = new google.maps.LatLngBounds();
    // // bounds.extend(markerInit.position);
    // for (var i = 1; i < this.arraySucursales.length; i++){
    //   var latLng = new google.maps.LatLng(this.arraySucursales[i].lat, this.arraySucursales[i].lng);
    //   var marker = this._addMarker(this.map, '/static/2016/d/public/img/markerinactive.svg', latLng);
    //   this.arrayMarkers.push(marker);
    //   var contenido = '<div><p>' + this.arraySucursales[i].address + '</p></div>'
    //   this._createWindowContent(inforWindow, this.map, contenido, marker);
    // }

    // this.map.fitBounds(bounds);
  },

  _drawContentMap: function (obj, inforWindow){
    var latLng = new google.maps.LatLng(obj.currentMarker.latitud, obj.currentMarker.longitud);
    var markerInit = obj._addMarker(obj.map, PATH_MARKET_ACTIVE, latLng);
    obj.arrayMarkers.push(markerInit);
    obj.map.setCenter(markerInit.position);
    var content = '<div><p>' + obj.currentMarker.direccion_est + '</p></div>';
    obj._createWindowContent(inforWindow, obj.map, content, markerInit);
    google.maps.event.trigger(markerInit, 'click');
    $('.title-sucursales').find('h2').text(obj.currentMarker.titulo_est);
    $('.somenumbers').text('/' + obj.arraySucursales.length);

    for (var i = 1; i < obj.arraySucursales.length; i++){
      var latLng = new google.maps.LatLng(obj.arraySucursales[i].latitud, obj.arraySucursales[i].longitud);
      var marker = obj._addMarker(obj.map, PATH_MARKET_INACTIVE, latLng);
      obj.arrayMarkers.push(marker);
      var contenido = '<div><p>' + obj.arraySucursales[i].direccion_est + '</p></div>'
      obj._createWindowContent(inforWindow, obj.map, contenido, marker);
    }
  },

  _createWindowContent: function (InfoWindow, mapa, content, marker){
    (function(marker, contenido, mapa) {
      google.maps.event.addListener(marker, 'click', function() {
        InfoWindow.setContent(contenido);
        InfoWindow.open(mapa, marker);
      });
    })(marker, content, mapa);
  },

  _addMarker: function(map, image, latLng){
    var icon = {
      url: image,
      size: new google.maps.Size(40, 52)
    };

    return new google.maps.Marker({
      position: latLng,
      map: map,
      icon: icon
    });
  },

  _next: function (evt){
    if (this.arraySucursales.length > 1) {
      var ind = this.arraySucursales.indexOf(this.currentMarker);
      var nextInd = (ind == (this.arraySucursales.length - 1)) ? 0 : ind + 1;
      this.currentMarker = this.arraySucursales[nextInd];
      $('.actualnumber').text(nextInd + 1);
      this._move(nextInd);
    }
  },

  _prev: function (evt){
    if (this.arraySucursales.length > 1){
      var ind = this.arraySucursales.indexOf(this.currentMarker);
      var prevInd = (ind == 0) ? this.arraySucursales.length - 1 : ind - 1;
      this.currentMarker = this.arraySucursales[prevInd];
      $('.actualnumber').text(prevInd + 1);
      this._move(prevInd);
    }
  },

  _move: function (index){
    this.map.panTo(new google.maps.LatLng(this.currentMarker.latitud, this.currentMarker.longitud));
    for (var i = 0; i < this.arrayMarkers.length; i++) {
      this.arrayMarkers[i].setIcon({
        url: PATH_MARKET_INACTIVE,
        size: new google.maps.Size(40, 52)
      })
    }
    this.arrayMarkers[index].setIcon({
      url: PATH_MARKET_ACTIVE,
      size: new google.maps.Size(40, 52)
    });
    google.maps.event.trigger(this.arrayMarkers[index], 'click');
    $('.title-sucursales').find('h2').text(this.currentMarker.titulo_est);
  },

  _setMapOnAll: function (map){
    for (var i = 0; i < this.arrayMarkers.length; i++) {
      this.arrayMarkers[i].setMap(map);
    }
  },

  _showMarkers: function(){
    this._setMapOnAll(this.map);
  },

  _deleteMarkers: function (){
    this._clearMarkers();
    this.arrayMarkers = [];
  },

  _clearMarkers: function(){
    this._setMapOnAll(null);
  },

  /**
   * Executes when the window is fully loaded.
   */
  load: function(){
    console.log("Load: Beneficio");
  }

});

// Create a instace of this page;
new Beneficio({ data: {} });
